import { render } from "./LabdaqPendingOrders.vue?vue&type=template&id=b2f6a4c2"
import script from "./LabdaqPendingOrders.vue?vue&type=script&lang=js"
export * from "./LabdaqPendingOrders.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/cases/LabdaqPendingOrders.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b2f6a4c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b2f6a4c2', __exports__)) {
    console.log('reload')
    api.reload('b2f6a4c2', __exports__)
  }
  
  module.hot.accept("./LabdaqPendingOrders.vue?vue&type=template&id=b2f6a4c2", () => {
    console.log('re-render')
    api.rerender('b2f6a4c2', render)
  })

}


export default __exports__